<template>
    <div class="detail-take-order-page">
        <div class="page-wrap">
            <div class="page-title">
                <span class="text1 backIcon" @click="back"><i class="el-icon-arrow-left"></i> 返回</span>
                <router-link class="text1" to="/">首页</router-link>
                <i class="el-icon-arrow-right arrow-right"></i>
                <router-link class="text1" to="/fabric">商品列表</router-link>
                <i class="el-icon-arrow-right arrow-right"></i>
                <span class="text2">商品详情</span>
            </div>
            <div class="mainInfoWrap">
                <div class="leftBox">
                    <div class="imgSection">
                        <div class="imgBox">
                            <viewer :images="[detail.flowerPic]" @inited="initedViewer">
                                <img :src="detail.flowerPic" alt="" class="mainImg">
                            </viewer>             
                        </div>
                        <div class="smallIconBox" @click="showViewer">
                            <i class="icon iconfont icon-fangdajing"></i>
                        </div>
                        <div class="smallCollectBox">
                            <span class="text">
                                <i class="icon iconfont icon-aixin1"></i>
                                收藏
                            </span>

                        </div>
                    </div>
                    <div class="tempImgLists">
                        <div class="oneImgItem">
                            <img :src="detail.flowerSmallPic" alt="" class="tempImg">
                        </div>
                    </div>
                </div>
                <div class="rightBox">
                    <div class="titleLine">
                        {{detailTitle}}
                    </div>
                    <div class="priceLine">
                        <span class="label">价格</span>
                        <span class="priceNum">￥{{currentPrice.content}}</span>
                        <span class="redBorderTag">{{buyType == 1 ? '不含面料' : '含面料' }}</span>
                    </div>
                    <div class="detailLine">
                        <div class="myLabel">编号</div>
                        <div class="myText">{{detail.flowerName}}</div>
                    </div>
                    <div class="detailLine">
                        <div class="myLabel">设计方</div>
                        <div class="myText">{{detail.stallName}}</div>
                        <!-- <span class="yellowArrow"> 
                            <i class="el-icon-arrow-right"></i>
                            <i class="el-icon-arrow-right"></i>
                        </span> -->
                        
                    </div>
                    <div class="detailLine">
                        <div class="myLabel">运费</div>
                        <div class="myText">包邮</div>
                    </div>
                    <div class="detailLine">
                        <div class="myLabel">类型</div>
                        <div class="myText">
                            
                            <el-radio-group v-model="buyType">
                                <el-radio :label="1" >
                                    加工
                                </el-radio>
                                <el-radio :label="2"  >
                                    经销
                                </el-radio>
                            </el-radio-group>
                            <div class="tyleBtnLine">
                                <button class="btn"
                                    :class="{active: item.id == currentPrice.id}"
                                    v-for="(item, index) in prices" :key="index" 
                                    style="margin-right: 16px;"
                                    @click="currentPrice = item"
                                >{{item.name}}</button>
                            </div>
                        </div>
                    </div>
                    <div class="detailLine" style="margin-top:30px;">
                        <div class="myLabel">品名</div>
                        
                            <div class="myText allCardBox" v-if="buyType == 1">
                                <div style="overflow: hidden">
                                    <el-collapse v-model="activeNames1"  v-for="(item, i) in cateData1" :key="i">
                                    <el-collapse-item :title="item.label" :name="item.value">
                                        <template slot="title">
                                                {{item.label}}
                                        </template>
                                        <div class="cardItem" v-for="(ele, j) in item.children" :key="j">{{ele.label}}</div>
                                    </el-collapse-item>
                                    </el-collapse>
                                </div>
                            </div>
                            <div class="myText allCardBox" v-if="buyType == 2">
                                <div style="overflow: hidden">
                                    <el-collapse v-model="activeNames2"  v-for="(item, i) in cateData2" :key="i">
                                    <el-collapse-item :title="item.label" :name="item.value">
                                        <template slot="title">
                                                {{item.label}}
                                        </template>
                                        <div class="cardItem" v-for="(ele, j) in item.children" :key="j">{{ele.label}}</div>
                                    </el-collapse-item>
                                    </el-collapse>
                                </div>
                            </div>
                        
                        
                        <!-- <div class="myText allCardBox">
                            <el-collapse v-model="activeNames"  v-for="(item,index) in cateData1" :key="index">
                              <el-collapse-item title="乔琪" :name="list.value">
                                <template slot="title">
                                       
                                        {{list.name}}
                                </template>
                                <div class="cardItem" v-for="list in 10">弹力乔其10MM</div>
                              </el-collapse-item>
                            </el-collapse>
                        </div> -->
                    </div>
                    <div class="detailLine">
                        <div class="myLabel">门幅</div>
                        <div class="myText">
                            <input type="text" class="smallInput" placeholder="请输入门幅">
                            <span class="unit">厘米</span>
                        </div>
                    </div>
                    <div class="detailLine">
                        <div class="myLabel">数量</div>
                        <div class="myText">
                            <input type="text" class="smallInput" placeholder="请输入数量">
                            <el-dropdown @command="changeUnits" placement="bottom-start">
                                <span class="el-dropdown-link unit">
                                    {{currentNumUnit.unit}}<i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item
                                        v-for="item in numUnits" :key="item.id"
                                        :command="item"
                                    >{{item.unit}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <div class="num-apply" v-if="currentNumUnit.id == 2">
                                一匹等于：<input type="text" class="miniInput" placeholder="请输入数量" value="45"> 米
                            </div>
                        </div>
                    </div>
                    <!-- <div class="detailLine">
                        <div class="myLabel blue">购买方式</div>
                    </div>
                    <div class="radioLine">
                        <el-radio-group v-model="buyType">
                            <el-radio :label="3" :class="{active:buyType==3}">
                                <span class="label">授权</span>
                                <span class="text">使用权，用于生产制造</span>

                            </el-radio>
                            <el-radio :label="6" :class="{active:buyType==6}">
                                <span class="label">买断</span>
                                <span class="text">所有权，花型自动下架</span>
                            </el-radio>
                        </el-radio-group>
                    </div> -->
                    <div class="buttonBox">
                        <button class="btn blueBtn" style="margin-right: 16px;">立即购买</button>
                        <button class="btn blueBorderBtn">加入购物车</button>
                    </div>
                </div>


            </div>
            
            <imgcontrol></imgcontrol>
        </div>
    </div>
</template>

<script>
    import api from '@/api/index.js'
    import request from '@/utils/request'
    import { cateData1, cateData2} from './cateData.js'
    import imgcontrol from './imgControlComponents.vue'
    let activeNames1 = cateData1.map(item => item.value)
    let activeNames2 = cateData1.map(item => item.value)
    export default {
        components:{imgcontrol}, 
        data() {
            return {
                cateData1,
                cateData2,
                modelLists:[],
                activeNames1,
                activeNames2,
                swiperOption: {
                    direction: 'vertical',
                    slidesPerView: 4,
                    spaceBetween: 5,
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true // 允许点击小圆点跳转
                    },
                    // slidesOffsetAfter : 50,
                    // slidesOffsetBefore : 50,
                    loop: false,
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    }
                },
                slideNumber: 1,
                buyType: 1, //购买方式
                dialogImgUrl: '',
                dialogImgVisible: false,
                loading: false,
                marks: {
                    0: '1x',
                    25: '2x',
                    50: '3x',
                    75: {
                        style: {
                            color: '#1989FA'
                        },
                        label: this.$createElement('strong', '4x')
                    },
                    100: {
                        style: {
                            color: '#1989FA'
                        },
                        label: this.$createElement('strong', '5x')
                    }
                },
                detail: {
                    flowerName: '',
                    stallName: '',
                    fileFormat: '',
                    fileLayered: '',
                    flowerBigPic: '',
                    flowerPic: '',
                    flowerSmallPic: ''
                },
                detailTitle: '',
                prices: [],
                currentPrice: {
                    content: ''
                },
                currentNumUnit: {id: 1, unit: '米'},
                numUnits: [
                    {id: 1, unit: '米'},
                    {id: 2, unit: '匹'},
                    {id: 3, unit: '码'},
                    {id: 4, unit: '条'},
                ]
            }
        },
        watch: {

        },
        created() {
            this.getData();
        },
        mounted() {},
        beforeDestroy() {},
        methods: {
            initedViewer(viewer) {
                this.$viewer = viewer
            },
            showViewer() {
                this.$viewer.show()
            },
            back() {
                this.$router.back()
            },
            changeUnits(e) {
                this.currentNumUnit = e
            },
            // 获取详情数据
            getData() {
                request({
                    url: api.getBuJuYunDetail,
                    data: {
                        id: this.$route.query.id,
                        type: '0'
                    }
                }).then(res => {
                    // console.log(res)
                    if (res.errorCode == 200) {
                        this.detail = res.data

                        // 图片地址
                        this.detail.flowerBigPic = api.imgPrev + res.data.flowerBigPic.replace(/^\/share/, '')
                        this.detail.flowerPic = api.imgPrev + res.data.flowerPic.replace(/^\/share/, '')
                        this.detail.flowerSmallPic = api.imgPrev + res.data.flowerSmallPic.replace(/^\/share/, '')
   
                        // 名称
                        try {
                            let typeList = JSON.parse(res.data.typeList)
                            let detailTitle = ''
                            typeList.forEach(a => {
                                a.detailList.forEach(b => {
                                    detailTitle += ' ' + b.name
                                })
                            });
                            this.detailTitle = detailTitle
                        } catch (error) {
                            console.log(error)
                        }
                        // 价格
                        try {
                            let prices = JSON.parse(res.data.prices)
                            this.prices = prices.map(item => {
                                return {
                                    ...item,
                                    content: parseFloat(item.content).toFixed(2)
                                }
                            })
                            this.currentPrice = this.prices[0]
                            // console.log(prices)
                            // let detailPrice = ''
                            // prices = prices.map(a => {
                            //     return '￥' + parseFloat(a.content).toFixed(2)
                            // })
                            // detailPrice = prices.join('~')
                            // this.detailPrice = detailPrice
                        } catch (error) {
                            console.log(error)
                        }
                    } else {
                        this.$message.error(res.errorMsg || '网络错误')
                    }
                })
            },

        }
    }
</script>

<style lang="scss">
    .el-collapse-item__content{
        padding-bottom:0;padding-top:8px;
    }
    .el-collapse-item__arrow{
        margin:0;
        position: absolute;
        left:0;
        font-size: 16px;;font-weight: 900;color:#000;
    }
    .el-collapse{border:0;}
    .el-collapse-item__wrap{border:0;}
    .el-collapse-item__header{
        position: relative;
        height: 36px;border:0;
        padding-left:20px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 20px;
        // .arrowIcon{font-size:14px;color:#000;font-weight: bold;margin-right: 8px;;}
    
    }
    .el-slider__button {
        background: #ff815c;
        width: 22px;
        height: 22px;
        border-radius: 24px;
        border: 2px solid #ffe4d6
    }

    .el-slider__button:hover,
    .el-slider__button.dragging {
        transform: scale(1.1);
    }

    .el-slider.is-vertical .el-slider__runway {
        width: 10px;
        background: #e1e1e1;
        border-radius: 10px;
    }

    .el-slider.is-vertical .el-slider__bar {
        width: 10px;
        background: #e1e1e1;
    }

    .el-slider.is-vertical .el-slider__button-wrapper {
        left: -13px;
    }

    
    .swiperFatherBox {/* 轮播图 */
        position: relative;
        // border: 1px solid blue;
        margin-top:24px;
        
        .smallPersonImg {
            width: 100%; height: 100%;
            display: block; 
        }
        .swiper-container {
            width: 100px;
            height: 592px;
            // border: 1px solid red;
            .swiper-slide{background: #ddd;          }
        } 
        .swiper-button-prev,.swiper-button-next{
            position: absolute; z-index:100; background: none; line-height: 30px;
            width: 104px;;height:30px; text-align: center;outline:none;
        }
        .swiper-button-prev{
            top:-10px;
            left:0px; 
        }
        .swiper-button-next{
            bottom:-32px;
            left:0px; 
            top:auto;
        }
        .el-icon-arrow-up,.el-icon-arrow-down{font-weight: 900;color:#000}
        .swiper-button-prev.swiper-button-disabled, .swiper-button-next.swiper-button-disabled{opacity: 0.3;; cursor: not-allowed !important;pointer-events: auto;}
    }

    
</style>
<style scoped="scoped" lang="scss">
    .unit{
        font-size: 14px;
        font-weight: 400;
        color: #3F33FF;
        line-height: 20px;
        margin-left:10px;
        outline: none;
    }
    .smallInput{
        width: 160px;
        height: 40px;
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        padding-left:12px;
    }
    .num-apply {
        width: 160px;
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 12px;
        border-radius: 0 0 2px 2px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-top: none;
        font-size: 12px;
        .miniInput {
            width: 60px;
            height: 24px;
            border: 1px solid rgba(0, 0, 0, 0.15);
            border-radius: 2px;
            text-indent: 6px;
            font-size: 12px;
        }
    }
    .allCardBox{
        width:430px;
        max-height: 400px;
        overflow: auto;
        &::-webkit-scrollbar {
            width: 9px;
            height: 9px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: #ddd;
            background-clip: padding-box;
            min-height: 28px;
        }
        &::-webkit-scrollbar-track-piece {
            background-color: #f8f8f8;
        }
    }
    .cardItem{display: inline-block;
        font-size: 12px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
        line-height: 20px;
        padding:0px 8px;
        background: rgba(0, 0, 0, 0.04);
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        margin-right: 24px;margin-bottom: 18px;
    }
    .tyleBtnLine{
        margin-top:16px;
        .btn{
            width: 74px;
            height: 32px;
            background: #FFFFFF;
            border-radius: 2px;
            border: 1px solid rgba(0, 0, 0, 0.15);
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.65);
        }
        .btn.active{
            background: #3F33FF;color:#fff;
        }
    }
    .redBorderTag{
        display: inline-block;
        width: 72px;
        height: 24px;
        border-radius: 2px;
        border: 1px solid #FF4D4F;
        font-size: 14px;
        font-weight: 500;
        color: #FF4D4F;
        line-height: 24px;text-align: center; vertical-align: text-bottom;
        margin-left:13px;
    }
    .yellowArrow{color:yellow}
    .blue {
        color: #3F33FF !important;
    }

    .detail-take-order-page {
        .page-title{padding:24px 0 40px;}
        background-color: #fff;

        


        .page-wrap {
            background-color: #fff;
            width: 1184px;
            margin: 0 auto;
            padding-bottom: 80px;

            .mainInfoWrap {
                display: flex;

                .leftBox {
                    .imgSection {
                        position: relative;

                        .imgBox {
                            width: 482px;
                            height: 482px;
                            border: 1px solid rgba(0, 0, 0, 0.06);
                            padding: 55px 104px;
                            box-sizing: border-box;

                            .mainImg {
                                width: 274px;
                                height: 373px;
                                cursor: zoom-in;
                            }
                        }

                        .smallIconBox {
                            width: 24px;
                            height: 24px;
                            position: absolute;
                            padding-right: 16px;
                            padding-bottom: 13px;
                            padding-left: 20px;
                            right: 0;
                            bottom: 0;
                            // right: 16px;
                            // bottom: 13px;
                            cursor: pointer;
                        }

                        .smallIconBox:hover {
                            color: #D9363E;
                        }

                        .smallCollectBox:hover {
                            color: #D9363E;
                        }

                        .smallCollectBox {
                            cursor: pointer;
                            position: absolute;
                            right: 0;
                            bottom: -44px;
                            color: rgba(0, 0, 0, 0.65);

                            .icon {
                                font-size: 12px;
                            }

                            .text {
                                font-size: 12px;
                                font-weight: 400;

                                line-height: 17px;
                            }
                        }
                    }

                    .tempImgLists {
                        margin-top: 32px;

                        .oneImgItem {
                            .tempImg {
                                width: 52px;
                                height: 72px;
                                border: 4px solid #FF4D4F;
                            }
                        }
                    }
                }

                .rightBox {
                    padding-left: 68px;

                    .titleLine {
                        font-size: 20px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.85);
                        line-height: 20px;
                    }

                    .priceLine {
                        margin-top: 24px;
                        width: 584px;
                        height: 112px;
                        line-height: 112px;
                        background: #F9F9F9;

                        .label {
                            font-size: 14px;
                            font-weight: 400;
                            color: rgba(0, 0, 0, 0.85);
                            line-height: 20px;
                            margin: 0 40px 0 24px;
                        }

                        .priceNum {
                            font-size: 28px;
                            font-weight: 600;
                            color: #D9363E;
                            line-height: 36px;
                        }
                    }

                    .detailLine {
                        margin-top: 24px;

                        .myLabel {
                            display: inline-block;
                            width: 56px;
                            text-align-last: justify;
                            letter-spacing: 0;
                            font-size: 14px;
                            font-weight: 400;
                            color: rgba(0, 0, 0, 0.65);
                            margin-right: 94px;
                            vertical-align: top;
                        }

                        .myText {
                            display: inline-block;
                            font-size: 14px;
                            font-weight: 400;
                            color: rgba(0, 0, 0, 0.65);
                            line-height: 20px;
                        }

                    }

                    .radioLine {
                        margin-top: 24px;
                        .el-radio {
                            display: block;
                            width: 584px;
                            box-sizing: border-box;
                            padding: 20px 13px;
                        
                            font-size: 14px;
                            font-weight: 400;
                            color: rgba(0, 0, 0, 0.65);
                            line-height: 20px;
                        
                            .label {
                                color: rgba(0, 0, 0, 0.85);
                                margin-right: 70px;
                            }
                        
                            .text {
                                color: rgba(0, 0, 0, 0.65);
                            }
                        }
                        
                        .el-radio.active {
                            background: rgba(63, 51, 255, 0.1);
                        }
                    }

                    .buttonBox {
                        margin-top: 32px;

                        .btn {
                            width: 234px;
                            height: 40px;
                            border-radius: 2px;
                            box-sizing: border-box;
                            font-size: 16px;
                            border: 1px solid #3F33FF;

                        }

                        .blueBorderBtn {
                            color: #3F33FF;
                            background: #fff;

                        }
                    }

                }
            }

            .showClothesBox {
                margin-top: 48px;

                .titleLine {
                    height: 40px;
                    padding-left: 21px;
                    line-height: 40px;
                    background: #F5F5F5;
                    border-radius: 2px;
                    border: 1px solid rgba(0, 0, 0, 0.15);
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.85);
                    border-bottom: 0;
                }

                .showBox {
                    width: 1184px;
                    height: 771px;
                    box-sizing: border-box;
                    background: #FFFFFF;
                    background: #fff;
                    border: 1px solid rgba(0, 0, 0, 0.15);
                    position: relative;

                    .leftBox {
                        width: 146px;
                        height: 674px;
                        box-sizing: border-box;
                        padding: 20px;
                        // border:1px solid red;
                        position: absolute;
                        top: 46px;
                        left: 120px;

                        .smallDes {
                            font-size: 12px;
                            margin-bottom:44px;
                            margin-top:-20px;
                            padding-left:4px;
                        }

                    }

                    .centerBox {
                        width: 444px;
                        height: 632px;
                        box-sizing: border-box;
                        padding: 20px;
                        position: absolute;
                        top: 88px;
                        left: 370px;

                        // border:1px solid red;
                        .mainPerson {
                            // width: 100%;
                            // height: 100%;

                        }
                    }

                    .rightBox {
                        position: absolute;
                        top: 85px;
                        right: 150px;
                        padding-top: 20px;
                        width: 70px;

                        .smallDes {
                            font-size: 12px;
                        }

                        .slideBox {
                            position: relative;
                            padding-top: 30px;

                            .slideLabelBox {
                                height: 300px;
                                position: absolute;
                                bottom: 5px;
                                left: -20px;

                                .oneItem {
                                    display: block;
                                    height: 74px;
                                    position: relative;
                                    line-height: 10px;

                                }

                                .oneItem:first-child:after {
                                    display: none;
                                }

                                .oneItem:last-child:after {
                                    display: none;
                                }

                                .oneItem:after {
                                    content: "";
                                    display: block;
                                    width: 12px;
                                    height: 12px;
                                    background: #e1e1e1;

                                    border-radius: 50%;
                                    position: absolute;
                                    right: -28px;
                                    top: 0;
                                }
                            }
                        }
                    }
                }
            }

        }



    }
</style>
